import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../Styles/Blackprofileapplication.css";
import ApiService from "../nhrc_apis/ApiService";

const Addblockprofile = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    employeeName:  "",
    designation:   "",
    photo:         null,
    status:        "",
    uan:           "",   // ✅ RENAMED from uid
    empId:         "",
    aadhar:        "",
    pan:           "",
    email:         "",
    phone:         "",
    location:      "",
    department:    "",
    modeOfWork:    "",
    reportingTo:   "",
    doj:           "",
    experience:    "",
    remarks:       "",
    documentName:  "",
    documentFile:  null,
    hrName:        "",
    organisation:  "",
    hrDepartment:  "",
  });

  const getMembershipId = () => {
    const token =
      localStorage.getItem("adminToken") ||
      localStorage.getItem("token");
    if (!token) return "ADMIN001";
    try {
      const base64  = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
      const decoded = JSON.parse(window.atob(base64));
      return decoded?.membership_id || "ADMIN001";
    } catch {
      return "ADMIN001";
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFile = (e) => {
    setForm({ ...form, [e.target.name]: e.target.files[0] });
  };

  const uploadFileToServer = async (file, fileType) => {
    if (!file) return "";
    const membership_id = getMembershipId();
    const formData = new FormData();
    formData.append("file",      file);
    formData.append("file_type", fileType);
    const response = await ApiService.UploadAPI.uploadFile(formData, membership_id);
    const raw =
      response.data?.url       ||
      response.data?.file_url  ||
      response.data?.image_url ||
      response.data?.photo_url ||
      response.data?.path      ||
      response.data?.filepath  ||
      response.data?.file_path ||
      (typeof response.data === "string" ? response.data : "") ||
      "";
    return raw;
  };

  const handleSubmit = async () => {
    if (!form.employeeName.trim()) { toast.error("Employee name is required!"); return; }
    if (!form.designation.trim())  { toast.error("Designation is required!");   return; }
    if (!form.uan.trim())          { toast.error("UAN Number is required!");    return; }
    if (!form.email.trim())        { toast.error("Email is required!");          return; }
    if (!form.phone.toString().trim()) { toast.error("Phone is required!");     return; }

    try {
      setLoading(true);

      // ─── STEP 1: Upload photo if selected ────────────
      let photo_url = "";
      if (form.photo) {
        try {
          photo_url = await uploadFileToServer(form.photo, "profile");
          console.log("PHOTO URL:", photo_url);
        } catch (err) {
          console.error("Photo upload error:", err?.response?.data);
          toast.error("Photo upload failed. Continuing without photo.");
        }
      }

      // ─── STEP 2: Upload document if selected ─────────
      let document_url = "";
      if (form.documentFile) {
        try {
          document_url = await uploadFileToServer(form.documentFile, "document");
          console.log("DOCUMENT URL:", document_url);
        } catch (err) {
          console.error("Document upload error:", err?.response?.data);
          toast.error("Document upload failed. Continuing without document.");
        }
      }

      const payload = {
        employee_name: form.employeeName.trim(),
        designation: form.designation.trim(),
        status: form.status.trim(),

        uan_number: form.uan.trim(),   // ✅ RENAMED from uid_number
        employee_id: form.empId.trim(),
        aadhaar_number: form.aadhar.toString().trim(),
        pan_number: form.pan.trim(),

        email: form.email.trim(),
        phone: form.phone.toString().trim(),
        location: form.location.trim(),
        department: form.department.trim(),
        mode_of_work: form.modeOfWork.trim(),
        reporting_to: form.reportingTo.trim(),

        date_of_joining: form.doj ? new Date(form.doj).toISOString() : null,

        experience: form.experience.trim(),
        remarks: form.remarks.trim(),

        document_name: form.documentName.trim(),
        document_url: document_url,

        photo_url: photo_url,

        hr_name: form.hrName.trim(),
        organisation: form.organisation.trim(),
        hr_department: form.hrDepartment.trim(),
      };

      console.log("BLACK PROFILE PAYLOAD:", payload);

      const response = await ApiService.BlackProfilesAPI.createBlackProfile(payload);
      console.log("BLACK PROFILE RESPONSE:", response.data);

      toast.success("Black Profile Submitted Successfully!");
      navigate("/dashboard/Blockprofile");

    } catch (err) {
      console.error("CREATE BLACK PROFILE ERROR:", err?.response?.data);
      console.error("FULL VALIDATION DETAIL:", JSON.stringify(err?.response?.data?.detail, null, 2));
      const detail = err?.response?.data?.detail;
      let msg = "Failed to submit. Try again!";
      if (Array.isArray(detail))             msg = detail.map((d) => d.msg).join(", ");
      else if (typeof detail === "string")   msg = detail;
      else if (err?.response?.data?.message) msg = err.response.data.message;
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const clearForm = () => {
    setForm({
      employeeName:  "",
      designation:   "",
      photo:         null,
      status:        "",
      uan:           "",   // ✅ RENAMED from uid
      empId:         "",
      aadhar:        "",
      pan:           "",
      email:         "",
      phone:         "",
      location:      "",
      department:    "",
      modeOfWork:    "",
      reportingTo:   "",
      doj:           "",
      experience:    "",
      remarks:       "",
      documentName:  "",
      documentFile:  null,
      hrName:        "",
      organisation:  "",
      hrDepartment:  "",
    });
  };

  return (
    <div className="bpa-container">
      <h2 className="bpa-title">Black Profile Application</h2>

      <div className="bpa-section">
        <div className="bpa-section-header">EMPLOYEE DETAILS</div>
        <div className="bpa-form">

          <div className="bpa-field">
            <label className="bpa-label">Name of the Employee*</label>
            <input type="text" name="employeeName" value={form.employeeName} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Designation*</label>
            <input type="text" name="designation" value={form.designation} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Upload Photo*</label>
            <input type="file" name="photo" accept="image/*" onChange={handleFile} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Status*</label>
            <input type="text" name="status" value={form.status} onChange={handleChange} />
          </div>

        </div>
      </div>

      <div className="bpa-section">
        <div className="bpa-section-header">IDENTIFIERS</div>
        <div className="bpa-form">

          <div className="bpa-field">
            <label className="bpa-label">UAN Number*</label>
            <input type="text" name="uan" value={form.uan} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Employee ID*</label>
            <input type="text" name="empId" value={form.empId} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Aadhar Number*</label>
            <input type="number" name="aadhar" value={form.aadhar} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Pan Number*</label>
            <input type="text" name="pan" value={form.pan} onChange={handleChange} />
          </div>

        </div>
      </div>

      <div className="bpa-section">
        <div className="bpa-section-header">CONTACT</div>
        <div className="bpa-form">

          <div className="bpa-field">
            <label className="bpa-label">Email ID*</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Phone Number*</label>
            <input type="number" name="phone" value={form.phone} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Location*</label>
            <input type="text" name="location" value={form.location} onChange={handleChange} />
          </div>

        </div>
      </div>

      <div className="bpa-section">
        <div className="bpa-section-header">EMPLOYMENT</div>
        <div className="bpa-form">

          <div className="bpa-field">
            <label className="bpa-label">Department*</label>
            <input type="text" name="department" value={form.department} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Mode of Work*</label>
            <input type="text" name="modeOfWork" value={form.modeOfWork} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Reporting to*</label>
            <input type="text" name="reportingTo" value={form.reportingTo} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Date of joining*</label>
            <input type="date" name="doj" value={form.doj} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Experience*</label>
            <input type="text" name="experience" value={form.experience} onChange={handleChange} />
          </div>

        </div>
      </div>

      <div className="bpa-section">
        <div className="bpa-section-header">REMARKS</div>
        <div className="bpa-form">
          <div className="bpa-field bpa-field-full">
            <label className="bpa-label">Remarks</label>
            <input type="text" name="remarks" value={form.remarks} onChange={handleChange} />
          </div>
        </div>
      </div>

      <div className="bpa-section">
        <div className="bpa-section-header">DOCUMENTS</div>
        <div className="bpa-form">

          <div className="bpa-field">
            <label className="bpa-label">Name of the Document*</label>
            <input type="text" name="documentName" value={form.documentName} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Upload Document*</label>
            <input type="file" name="documentFile" onChange={handleFile} />
          </div>

        </div>
      </div>

      <div className="bpa-section">
        <div className="bpa-section-header">HR DETAILS</div>
        <div className="bpa-form">

          <div className="bpa-field">
            <label className="bpa-label">Name of the HR*</label>
            <input type="text" name="hrName" value={form.hrName} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Organisation*</label>
            <input type="text" name="organisation" value={form.organisation} onChange={handleChange} />
          </div>

          <div className="bpa-field">
            <label className="bpa-label">Department*</label>
            <input type="text" name="hrDepartment" value={form.hrDepartment} onChange={handleChange} />
          </div>

        </div>
      </div>

      <div className="bpa-action-container">
        <button className="bpa-submit-btn" onClick={handleSubmit} disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
        <button className="bpa-clear-btn" onClick={clearForm} disabled={loading}>
          Clear
        </button>
        <button className="bpa-back-btn" onClick={() => navigate(-1)} disabled={loading}>
          Back
        </button>
      </div>

    </div>
  );
};

export default Addblockprofile;